import BarcodeReaderInput from '@/components/fields/barcode-reader-input.vue';

import { validationMixin } from 'vuelidate';
import { required, maxLength, email, requiredIf } from 'vuelidate/lib/validators';

export default {
    components : {
        BarcodeReaderInput
    },
    mixins: [validationMixin],

    validations: {
        fieldSerialNumber    : {
            required : requiredIf(function (model) {
                if (this.selectedProductInfos.length > 0) {
                    return true;
                }
                return false;
            }),
            maxLength : maxLength(50)
        },
    },
    props: {
        productInfos       :  {
            type    : Object,
            default : {}
        },
    },
    data () {
        return {
            selectedProductInfos    : [],
        };
    },
    watch: {
        productInfos(product) {
            let productInfo = {};
            productInfo =  {
                'detail'    : product.inventorynumber,
                'label'     : 'inventory-number'
            };
            this.selectedProductInfos.push(productInfo);
            productInfo =  {
                'detail'    : product.eannumber,
                'label'     : 'ean-number'
            };
            this.selectedProductInfos.push(productInfo);
            productInfo =  {
                'detail'    : product.brandName,
                'label'     : 'brand-name'
            };
            this.selectedProductInfos.push(productInfo);
            productInfo =  {
                'detail'    : product.name[this.$i18n.locale],
                'label'     : 'model-name'
            };
            this.selectedProductInfos.push(productInfo);
        },
    },
    methods : {
        resetValues() {
            this.selectedProductInfos   = [];
            this.$refs.fieldSerialNumber.resetValue();
        },
        getValues() {
            let ret = {};
            ret.swapProductInventoryNumber  = this.productInfos.inventorynumber;
            ret.swapProductEanNumber        = this.productInfos.eannumber;
            ret.swapProductBrandName        = this.productInfos.brandName;
            ret.swapProductName             = this.productInfos.name[this.$i18n.locale];
            ret.swapProductSerialNumber     = this.$refs.fieldSerialNumber.getValue();

            return ret;
        }
    },
    computed: {
        fieldSerialNumberErrors () {
            const errors = [];
            if (!this.$v.fieldSerialNumber.$dirty) {
                return errors;
            }
            if (!this.$v.fieldSerialNumber.maxLength) {
                errors.push('fieldSerialNumber must be at most 50 characters long');
            }
            if (!this.$v.fieldSerialNumber.required) {
                errors.push('fieldSerialNumber is required.');
            }
            return errors;
        },
    },

};
